module.exports = __webpack_public_path__ + "img/flag_rect_31.c1c38590.png";